// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3EaN9","text":"SelectPayment_text__1FUN7","title":"SelectPayment_title__15JF8","btn":"SelectPayment_btn__HY7lV"};